import { useTheme } from "@mui/material";
import { BNBox, BNInlineSvgIcon, BNListItem, getRouteAction } from "@bn-monorepo/js-packages";
import { ExpandMore } from "@mui/icons-material";
import { BNListItemProps } from "@bn-monorepo/js-packages/src/Components/BNListItem/BNListItem";

interface Props extends BNListItemProps {
  level: 1 | 2;
  iconDirection?: "down" | "right";
  hideExpandIcon?: boolean;
  iconInlineSvg?: string;
  showArrowForward: boolean;
}

export const BNHeaderMegaMenuLink: React.FC<Props> = ({
  level,
  children,
  sx,
  to,
  iconDirection = "right",
  showArrowForward,
  iconInlineSvg,
  ...restOfProps
}) => {
  const theme = useTheme();
  return (
    <BNListItem
      color={level == 1 ? theme.vars.palette.secondary.lighter : theme.vars.palette.background.paper}
      textSx={{ fontWeight: "normal", color: theme.vars.palette.tertiary.dark }}
      showArrowForward={showArrowForward}
      sx={{ borderRadius: 0, outlineColor: "black !important", ...sx }}
      icon={
        iconInlineSvg ? (
          <BNInlineSvgIcon
            svgString={iconInlineSvg}
            sx={{
              color: theme.vars.palette.tertiary.dark,
              width: "2.4rem",
              height: "2.4rem",
            }}
          />
        ) : undefined
      }
      overrideLinkIcon={
        showArrowForward ? (
          <ExpandMore
            sx={{
              color: "tertiary.main",
              transform: iconDirection === "right" ? "rotate(-90deg)" : undefined,
            }}
          />
        ) : undefined
      }
      to={to}
      data-uit={getRouteAction(to?.toString())}
      {...restOfProps}
    >
      <BNBox>{children}</BNBox>
    </BNListItem>
  );
};
